<template>
  <div
    class="container-fluid"
    style="display: flex; justify-content: center; align-items: center;"
  >
    <div :class="forConasi ? 'login-page-conasi' : 'login-page'">
      <div class="form-login">
        <div class="title-login">
          {{ $t('login.login') }}
        </div>
        <form>
          <div class="form-row">
            <div class="form-group col-md-12" style="margin-bottom:35px;">
              <!-- <label class="required" for="inputUsername">Tên tài khoản</label> -->
              <div class="form-content">
                <div class="icon">
                  <i class="far fa-envelope"></i>
                </div>
                <div class="input-username">
                  <input
                    v-model="username"
                    type="text"
                    class="form-control"
                    id="inputUsername"
                    :placeholder="$t('login.username')"
                    v-bind:class="{
                      'form-control': true,
                      'is-invalid': !validRequire(username) && fieldBlured,
                    }"
                    v-on:blur="fieldBlured = true"
                    @keydown.enter="checkLoginForm($event)"
                  />
                  <span class="invalid-feedback">{{ $t("common.requiredFields") }}</span>
                </div>
              </div>
            </div>
            <div class="form-group col-md-12">
              <!-- <label class="required" for="inputPassword">Mật khẩu</label> -->
              <div class="form-content">
                <div class="icon">
                  <i class="fas fa-lock"></i>
                </div>
                <div class="input-username">
                  <input
                    v-model="password"
                    type="password"
                    class="form-control"
                    id="inputPassword"
                    :placeholder="$t('login.password')"
                    v-bind:class="{
                      'form-control': true,
                      'is-invalid': !validRequire(password) && fieldBlured,
                    }"
                    v-on:blur="fieldBlured = true"
                    @keydown.enter="checkLoginForm($event)"
                  />
                  <span class="invalid-feedback">{{ $t("common.requiredFields") }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="form-footer">
            <div class="link-action">
              <p @click="nextForgotPasswordPage">{{ $t('login.forgotPassword') }}</p>
            </div>
            <div class="button-login">
              <b-button
                size="md"
                variant="outline-success"
                class="mb-2"
                @click="checkLoginForm($event)"
              >
                {{ $t('login.login') }}
              </b-button>
            </div>
          </div>
          <div class="or-seperator"></div>
          <div style="flex-wrap: wrap; display: flex;">
            <div class="col-sm-12 col-md-6 col-lg-6" style="padding: 5px">
              <google-button-component
                v-if="ENABLE_BINDING_GOOGLE"
                :data-width="147"
                style="margin: 0"
                @onEmitData="googleBtnEmitData"
              />
            </div>
            <div class="col-sm-12 col-md-6 col-lg-6" style="padding: 5px">
              <a
                v-if="ENABLE_BINDING_FACEBOOK"
                class="btn btn-primary btn-block btn-social"
                @click="onClickLoginFacebook">
                <i class="fab fa-facebook"/> {{ $t('common.loginWithFacebook') }}
              </a>
            </div>
          </div>
          <!--  -->
          <!-- <button class="button signin" type="button">
              <img src="@/assets/Google-Button.svg" />
            <span class="button-label">{{ $t('common.loginWithGoogle') }}</span>
          </button> -->
          <!--  -->
          <!-- <button class="button signin" type="button">
            <span class="button-icon google">
              <svg viewBox="0 0 366 372" xmlns="http://www.w3.org/2000/svg">
                <path d="M125.9 10.2c40.2-13.9 85.3-13.6 125.3 1.1 22.2 8.2 42.5 21 59.9 37.1-5.8 6.3-12.1 12.2-18.1 18.3l-34.2 34.2c-11.3-10.8-25.1-19-40.1-23.6-17.6-5.3-36.6-6.1-54.6-2.2-21 4.5-40.5 15.5-55.6 30.9-12.2 12.3-21.4 27.5-27 43.9-20.3-15.8-40.6-31.5-61-47.3 21.5-43 60.1-76.9 105.4-92.4z" fill="#EA4335"/><path d="M20.6 102.4c20.3 15.8 40.6 31.5 61 47.3-8 23.3-8 49.2 0 72.4-20.3 15.8-40.6 31.6-60.9 47.3C1.9 232.7-3.8 189.6 4.4 149.2c3.3-16.2 8.7-32 16.2-46.8z" fill="#FBBC05"/><path d="M361.7 151.1c5.8 32.7 4.5 66.8-4.7 98.8-8.5 29.3-24.6 56.5-47.1 77.2l-59.1-45.9c19.5-13.1 33.3-34.3 37.2-57.5H186.6c.1-24.2.1-48.4.1-72.6h175z" fill="#4285F4"/><path d="M81.4 222.2c7.8 22.9 22.8 43.2 42.6 57.1 12.4 8.7 26.6 14.9 41.4 17.9 14.6 3 29.7 2.6 44.4.1 14.6-2.6 28.7-7.9 41-16.2l59.1 45.9c-21.3 19.7-48 33.1-76.2 39.6-31.2 7.1-64.2 7.3-95.2-1-24.6-6.5-47.7-18.2-67.6-34.1-20.9-16.6-38.3-38-50.4-62 20.3-15.7 40.6-31.5 60.9-47.3z" fill="#34A853"/>
              </svg>
            </span>
            <span class="button-label">{{ $t('common.loginWithGoogle') }}</span>
          </button> -->
        </form>
        <div style="clear: both;"></div>
        <div class="text-center" style="margin-top:30px;">
          <span
            >{{ $t('login.doNotHaveAnAccount') }} </span>
            <div class="link-action">
              <span @click="onGoScreenRegister($event)">{{ $t('login.createNewAccount') }}</span>
            </div>
        </div>
      </div>
    </div>
    <!--  -->
    <div
      id="confirmCreateAccountWithGoogle"
      class="modal fade"
      data-keyboard="false"
      data-backdrop="static"
    >
      <div class="modal-dialog modal-confirm">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">{{ $t('common.notification') }}</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-hidden="true"
              @click="cancelCreateAccount"
            >
              &times;
            </button>
          </div>
          <div class="modal-body">
            <!-- <p>{{ modalData.content }}</p> -->
            <p>{{ $t('socialNetwork.notiConfirmCreateAccountWithGoogle') }}</p>
          </div>
          <div class="modal-footer">
            <button
              class="btn btn-warning btn-sm float-left"
              data-dismiss="modal"
              @click="cancelCreateAccount"
            >
              <span>{{ $t("common.cancel") }}</span>
            </button>
            <button
              class="btn btn-success btn-sm float-right"
              data-dismiss="modal"
              @click="confirmCreateAccount"
            >
              <span>{{ $t("common.confirm") }}</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import LoginFromType from 'Enum/loginFromType'
import SocialNetworkType from 'Enum/socialNetworkType'
import stringUtils from 'Utils/stringUtils'
import functionUtils from 'Utils/functionUtils'
import GoogleButtonComponent from 'Components/GoogleButtonComponent'
import { FOR_CONASI_TARGET } from 'Utils/constants'
import { initFbsdk } from '@/config/facebook_oAuth.js'
import $ from "jquery";
export default {
  components: {
    GoogleButtonComponent
  },
  data: () => ({
    username: "",
    password: "",
    fieldBlured: false,
    placeholderUsername: '',
    placeholderPassword: '',
    forConasi: FOR_CONASI_TARGET,
    ENABLE_BINDING_GOOGLE: process.env.VUE_APP_ENABLE_BINDING_GOOGLE.trim() === 'true',
    ENABLE_BINDING_FACEBOOK: process.env.VUE_APP_ENABLE_BINDING_FACEBOOK.trim() === 'true',
    isConfirmCreateAccount: false,
    googleData: null
  }),
  methods: {
    /**
     * Valid require
     */
    validRequire: function(fieldRequire) {
      if (fieldRequire != "" && fieldRequire != null) {
        return true;
      } else {
        return false;
      }
    },

    checkLoginForm: function (event) {
      event.preventDefault()
      this.fieldBlured = true;
      if (this.validRequire(this.username) && this.validRequire(this.password)) {
        this.onLogin()
      }
    },
    /**
     * Login
     */
    onLogin: function() {
      let filter = {
        username: this.username.toLowerCase().trim(),
        password: this.password.trim(),
        fromType: LoginFromType.CUSTOMER
      };
      this.LOGIN(filter).then(
        function() {
          this.$toast.clear()
          this.$toast.success(this.$t('common.notificationToast.success'), {
            position: "bottom-left",
            timeout: 1500,
            closeOnClick: true,
            pauseOnFocusLoss: true,
            pauseOnHover: true,
            draggable: true,
            draggablePercent: 0.6,
            showCloseButtonOnHover: false,
            hideProgressBar: false,
            closeButton: "button",
            icon: true,
            rtl: false
          });
          this.SET_USER_DATA();
          this.$router.push({
            path: "/my-voucher",
          });
        }.bind(this)
      ).catch(
          function (error) {
            this.isLoading = false
            if (error.message === stringUtils.NETWORK_ERROR) {
              this.$toast.clear()
              this.$toast.error(this.$t('common.networkError'), {
                position: "bottom-left",
                timeout: 1500,
                closeOnClick: true,
                pauseOnFocusLoss: true,
                pauseOnHover: true,
                draggable: true,
                draggablePercent: 0.6,
                showCloseButtonOnHover: false,
                hideProgressBar: false,
                closeButton: "button",
                icon: true,
                rtl: false
              });
            } else if (!functionUtils.isNull(error.response.data.message)) {
              if (error.response.status === 401) {
                this.$toast.clear()
                this.$toast.error(this.$t('login.loginInvalid'), {
                  position: "bottom-left",
                  timeout: 1500,
                  closeOnClick: true,
                  pauseOnFocusLoss: true,
                  pauseOnHover: true,
                  draggable: true,
                  draggablePercent: 0.6,
                  showCloseButtonOnHover: false,
                  hideProgressBar: false,
                  closeButton: "button",
                  icon: true,
                  rtl: false
                });
              } else {
                this.$toast.clear()
                this.$toast.error(this.$t(error.response.data.message), {
                  position: "bottom-left",
                  timeout: 1500,
                  closeOnClick: true,
                  pauseOnFocusLoss: true,
                  pauseOnHover: true,
                  draggable: true,
                  draggablePercent: 0.6,
                  showCloseButtonOnHover: false,
                  hideProgressBar: false,
                  closeButton: "button",
                  icon: true,
                  rtl: false
                });
              }
            } else {
              this.$toast.clear()
              this.$toast.error(this.$t('login.somethingWentWrong'), {
                position: "bottom-left",
                timeout: 1500,
                closeOnClick: true,
                pauseOnFocusLoss: true,
                pauseOnHover: true,
                draggable: true,
                draggablePercent: 0.6,
                showCloseButtonOnHover: false,
                hideProgressBar: false,
                closeButton: "button",
                icon: true,
                rtl: false
              });
            }
          }.bind(this)
        )
    },
    onGoHome: function () {
      this.$router.push('/look-up-voucher')
    },
    /**
     * Go screen register
     */
    onGoScreenRegister: function(event) {
      event.preventDefault();
      this.$router.push({
        name: "register",
      });
    },
    ...mapActions(["LOGIN", "SET_USER_DATA", "LOGIN_WITH_GOOGLE"]),
    nextForgotPasswordPage() {
      this.$router.push('/forgot-password')
    },

    // Localstorage locale
    changeLanguage() {
      if (localStorage.getItem('locale') === 'vi') {
        this.placeholderUsername = 'Tên tài khoản'
        this.placeholderPassword = 'Mật Khẩu'
      }
      else {
        this.placeholderUsername = 'Username'
        this.placeholderPassword = "Password"
      }
    },
    googleBtnEmitData: function (data) {
      if (data) {
        let id = data.id
        this.checkGoogleLogin(id, SocialNetworkType.GOOGLE, true, data)
      }
    },
    onClickLoginGoogle: function () {
      this.$gAuth
        .signIn()
        .then(GoogleUser => {
          // on success do something
          var profile = GoogleUser.getBasicProfile();
          var fullName = profile.getName()
          var avatarUrl = profile.getImageUrl()
          var email = profile.getEmail()
          if (Object.keys(profile).length > 0) {
            let id = profile.getId()
            let userProfile = {
              id: id,
              fullName: fullName,
              avatarUrl: avatarUrl,
              email: email
            }
            this.googleData = userProfile
            this.checkGoogleLogin(id, SocialNetworkType.GOOGLE, true, userProfile)
          }
        })
        // .catch(error => {
        //   console.log('error', error)
        // })
    },
    checkGoogleLogin: function (socialId, socialType, isCustomerPortal, extraInfo) {
      let data = {
        socialId: socialId,
        socialType: socialType,
        isConfirmCreateAccount: this.isConfirmCreateAccount
      }
      if (extraInfo) {
        data['fullName'] = extraInfo.fullName
        data['avatarUrl'] = extraInfo.avatarUrl
        data['email'] = extraInfo.email
      }
      if (isCustomerPortal) {
        data['isCustomerPortal'] = isCustomerPortal
      }
      this.isLoading = true
      this.LOGIN_WITH_GOOGLE(data).then(
        function (res) {
          let isShowModalConfirmCreateAccount = res.data.isShowModalConfirmCreateAccount !== undefined
            ? res.data.isShowModalConfirmCreateAccount : null
          if (isShowModalConfirmCreateAccount === null) {
            this.$toast.clear()
            this.$toast.success(this.$t('common.notificationToast.success'), {
              position: "bottom-left",
              timeout: 1500,
              closeOnClick: true,
              pauseOnFocusLoss: true,
              pauseOnHover: true,
              draggable: true,
              draggablePercent: 0.6,
              showCloseButtonOnHover: false,
              hideProgressBar: false,
              closeButton: "button",
              icon: true,
              rtl: false
            });
            this.SET_USER_DATA();
            this.$router.push({
              path: "/my-voucher",
            });
          } else {
            // 
            // this.isShowModalConfirmCreateAccount = isShowModalConfirmCreateAccount
            this.onShowModal()
          }
        }.bind(this)
      ).catch(
        function (error) {
          this.isLoading = false
          if (!functionUtils.isNull(error.response.data.errorText)) {
            let errorText = error.response.data.errorText
            this.$toast.clear()
            this.$toast.error(this.$t(errorText), {
              position: "bottom-left",
              timeout: 2500,
              closeOnClick: true,
              pauseOnFocusLoss: true,
              pauseOnHover: true,
              draggable: true,
              draggablePercent: 0.6,
              showCloseButtonOnHover: false,
              hideProgressBar: false,
              closeButton: "button",
              icon: true,
              rtl: false
            });
          } else {
            this.$toast.clear()
            this.$toast.error(this.$t('login.somethingWentWrong'), {
              position: "bottom-left",
              timeout: 1500,
              closeOnClick: true,
              pauseOnFocusLoss: true,
              pauseOnHover: true,
              draggable: true,
              draggablePercent: 0.6,
              showCloseButtonOnHover: false,
              hideProgressBar: false,
              closeButton: "button",
              icon: true,
              rtl: false
            });
          }
        }.bind(this)
      )
    },
    onClickLoginFacebook: function () {
      window.FB.login(response => {
        if (response && response.authResponse) {
          window.FB.api(`/${response.authResponse.userID}`, userResponse => {
            if (userResponse) {
              this.checkGoogleLogin(userResponse.id, SocialNetworkType.FACEBOOK)
            }
          }, this.params)
        }
      }, this.params)
    },
    onShowModal: function () {
      $("#confirmCreateAccountWithGoogle").modal("show");
    },
    onHideModal: function () {
      $("#confirmCreateAccountWithGoogle").modal("hide");
    },
    confirmCreateAccount: function () {
      this.isConfirmCreateAccount = true
      this.checkGoogleLogin(this.googleData.id, SocialNetworkType.GOOGLE, true, this.googleData)
    },
    cancelCreateAccount: function () {
      this.isConfirmCreateAccount = false
      this.onHideModal()
    }
  },
  mounted() {
    initFbsdk()
  },
  created() {
    this.changeLanguage();
    initFbsdk()
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/color.scss";
.login-page-conasi {
  width: 33vw;
  height: auto;
  .form-login {
    background-color: #F7FAFC;
    box-shadow: 0 0px 17px 0 rgba(0, 0, 0, 0.1);
    padding: 16px 38px 15px 38px;
    border-radius: 10px;
    ::-webkit-input-placeholder, /* Edge */
    :-ms-input-placeholder, /* Internet Explorer */
    ::placeholder {
      font-size: 14px;
      color: $primary;
    }
    .invalid-feedback {
      position:absolute;
      transform:translate(10px,10px);
    }
    input, select, textarea{
      color: $primary;
    }
    .title-login {
      font-size: 18px;
      font-weight: 600;
      color: $primary;
      text-align: center;
      margin: 16px 0 74px 0;
      text-transform: uppercase;
    }
    input {
      border: none;
      color: $primary !important;
      &:focus {
        box-shadow: none;
      }
    }
    form {
      .form-content {
        display: flex;
        align-items: center;
        border: none;
        height: 50px;
        box-shadow: 0 0px 5px 0 rgba(0, 0, 0, 0.1);
        background-color: #fff;
        border-radius: 5px;
        padding: 16px 0px 16px 20px;
        .icon {
          display: flex;
          align-items: center;
          svg {
            font-size: 22px;
            color: $primary;
          }
        }
        .input-username {
          width: calc(100% - 18px);
        }
      }
    }
  }
  .form-footer {
    .link-action {
      display: flex;
      justify-content: flex-end;
      margin-top: 20px;
    }
    .button-login {
      display: flex;
      justify-content: center;
      button {
        background-color: $primary;
        color: #fff;
        border: $primary;
        margin-top: 10px;
        &:hover {
          background-color: #a5563e;
        }
        &:focus {
          box-shadow: 0 0 0 0.2rem rgba(227,137,137,.5);
        }
      }
    }
  }
  .link-action {
    color: #28a745;
    cursor: pointer;
    p {
      &:hover {
        color: #124f20
      }
      &:active {
        color: #28a745;
      }
    }
  }
}
.login-page {
  min-width: 300px;
  height: auto;
  .form-login {
    // padding: 1em 1em 1em 1em;
    // border-radius: 10px;
    ::-webkit-input-placeholder, /* Edge */
    :-ms-input-placeholder, /* Internet Explorer */
    ::placeholder {
      font-size: 14px;
      color: lightgrey;
    }
    .invalid-feedback {
      position:absolute;
      transform:translate(10px,2px);
    }
    input, select, textarea{
      color: $text-input-form;
    }
    .title-login {
      font-size: 20px;
      font-weight: 600;
      color: $btn-background;
      text-align: center;
      margin: 1em 0 1em 0;
      text-transform: uppercase;
    }
    input {
      border: none;
      color: $text-input-form !important;
      &:focus {
        box-shadow: none;
      }
    }
    form {
      .form-content {
        display: flex;
        align-items: center;
        border: none;
        height: 40px;
        box-shadow: 0 0px 5px 0 rgba(0, 0, 0, 0.1);
        background-color: #fff;
        border-radius: 5px;
        padding: 8px 0px 8px 8px;
        .icon {
          display: flex;
          align-items: center;
          svg {
            font-size: 22px;
            color: $btn-background;
          }
        }
        .input-username {
          width: calc(100% - 18px);
        }
      }
    }
  }
  .form-footer {
    .link-action {
      display: flex;
      justify-content: flex-end;
      margin-top: 10px;
    }
    .button-login {
      display: flex;
      justify-content: center;
      button {
        background-color: $btn-background;
        color: $text-primary;
        border: $btn-background;
        padding: .5em 3em;
        &:hover {
          background-color: #a5563e;
        }
        &:focus {
          box-shadow: 0 0 0 0.2rem rgba(227,137,137,.5);
        }
      }
    }
  }
  .link-action {
    color: $text-second;
    cursor: pointer;
    p, span {
      &:hover {
        color: #124f20
      }
      &:active {
        color: #28a745;
      }
    }
  }
}
@media only screen and (max-width: 1200px) {
  .login-page-conasi {
    width: 70vw;
  }
}

@media only screen and (max-width: 769px) {
  .login-page-conasi {
    width: 90vw;
  }
}
.or-seperator {
  margin: 10px 0;
  text-align: center;
  border-top: 1px solid #ccc;
}

// 
// .button {

//     display: inline-block;

//     position: relative;

//     color: #3c4043;

//     background: rgba(0,0,0,0);

//     font-family: Roboto,Arial,sans-serif;

//     font-size: 14px;

//     cursor: pointer;

//     white-space: nowrap;

//     // height: 37px;

//     // line-height: 37px;

//     padding: 0 8px 0 0;

//     border: 1px solid rgb(66, 133, 244);

//     -webkit-border-radius: 4px;

//     border-radius: 4px;

//     outline: none;
//     width: 100%;
//     text-align: left;

// }

// // .button:hover {

// //     color: rgba(0,0,0,.68);

// //     border-color: rgba(0,0,0,.54);

// // }

// .button:active, .button:focus {

//     outline: 0;

//     color: #3c4043;

// }

// .button .button-icon {

//     display: inline-block;

//     margin-right: 8px;

// }

// .button .button-icon.google,.button .button-icon.google svg {

//     width: 18px;

//     height: 18px;

// }

// .button .button-icon.facebook {

//     width: 23px;

//     height: 23px;

// }

// .button .button-icon.facebook svg {

//     fill: #3b5998!important;

//     height: 23px;

//     width: 23px;

// }

// .button .button-icon svg {

//     height: auto;

//     width: auto;

//     min-width: auto;

//     vertical-align: middle;

// }

// .button.signout,.button.logout {

//     display: none;

// }

.btn-social {
  position: relative;
  padding-left: 44px;
  text-align: left;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 14px;
  height: 34px;
}

.btn-social>:first-child {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 32px;
  height: 100%;
  line-height: 34px;
  font-size: 1.6em;
  text-align: center;
  border-right: 1px solid rgba(0,0,0,0.2);
}

.btn-google {
  color: #fff;
  border-color: rgba(0,0,0,0.2);
  background: rgb(66, 133, 244);
}
</style>
